import { useDispatch, useSelector, useStore, TypedUseSelectorHook } from "react-redux";
import { AppDispatch, AppStore, RootState } from "@/redux/store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = () => useStore<AppStore>();
